import { createContext } from 'react';
import { type IdTokenClaims } from '@Shared/auth/auth-profile';
import { type MeResponse } from '@Shared/profile/profile.service';

export type ImpersonatedUser = MeResponse;

export interface AuthContextValue {
  token: string;
  claims: IdTokenClaims;
  initialClaims: IdTokenClaims;
  isCrewAdmin: boolean;
  impersonate: (employeeId: string) => void;
  stopImpersonation: () => void;
  isImpersonating: boolean;
  isError: boolean;
  impersonatedUser: ImpersonatedUser | null;
}

export const AuthContext = createContext<AuthContextValue>({} as AuthContextValue);
